import React from "react";
import { LoadingButton } from "@mui/lab";
import { Box, Modal, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const CancelReservationModal = ({
  isOpen,
  onCancel,
  onSubmit,
  isReservation,
  isPayment,
}) => {
  console.log(isPayment, "aysuh@123");
  const { t } = useTranslation();
  return (
    <Modal
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      open={isOpen}
    >
      <Box
        sx={{
          background: "white",
          width: "480px",
          maxWidth: "95vw",
          p: 2,
          borderRadius: 1,
        }}
      >
        <Box>
          {isPayment ? (
            <>
              <Typography fontSize={20} color={"#605E5C"} variant="fontSize16">
                {t("components.cancelReservationModel.text05")}
              </Typography>
            </>
          ) : (
            <>
              <Typography fontSize={20} color={"#323130"} variant="h6">
                {isReservation
                  ? t("components.cancelReservationModel.text01")
                  : t("components.cancelReservationModel.text03")}
              </Typography>

              <Typography fontSize={16} color={"#605E5C"} variant="fontSize16">
                {isReservation
                  ? t("components.cancelReservationModel.text02")
                  : t("components.cancelReservationModel.text04")}
              </Typography>
            </>
          )}

          <Box mt={2} display={"flex"} justifyContent={"space-around"}>
            <LoadingButton
              size="small"
              sx={{ height: "40px", width: "100px" }}
              variant="outlined"
              type="submit"
              style={{
                backgroundColor: "#fff",
                borderColor: "#8A8886",
                color: "#605E5C",
                width: "100px",
              }}
              onClick={onCancel}
            >
              {t("commonLabels.text22")}
            </LoadingButton>

            <LoadingButton
              size="small"
              sx={{ width: "100px", height: "40px" }}
              loading={false}
              color="primary"
              onClick={onSubmit}
              variant="contained"
            >
              {t("commonLabels.text21")}
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

CancelReservationModal.propTypes = {};

export default React.memo(CancelReservationModal);
